<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>21. Nutzung von Cloud-Lösungen</h2>
          <p></p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "CloudUse2",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: "Für welchen Zweck setzt Ihre Organisation Cloud-Lösungen ein?"
        },
        colors: ["#444", "#7d9b38"],

        xAxis: {
          categories: [
            "CRM- oder ERP-Anwendungen",
            "Konferenzlösungen",
            "Media- & Kreativlösungen",
            "Kollaborations-Tools & Chat",
            "E-Mail",
            "Datensicherung",
            "Teilen von Dokumenten"
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        plotOptions: {
          series: {
            stacking: "normal"
          }
        },
        legend: {
          reversed: true
        },
        series: [
          {
            name: "Nein",
            data: [90.4, 82.2, 82.1, 73.6, 54.7, 40.6, 13.1]
          },
          {
            name: "Ja",
            data: [9.6, 17.8, 17.9, 26.4, 45.3, 59.4, 86.9]
          }
        ],
        exporting: {
          enabled: true,
          fallbackToExportServer: false
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
